import Styles from './assets/splitModalStyles.scss';
import { ISplitModalProps } from './entities';

const BCSplitModal = (props: ISplitModalProps) => {
	const renderLeftSide = () => {
		if (props.renderLeftSide) {
			return props.renderLeftSide();
		}
	};

	const renderRightSide = () => {
		if (props.renderRightSide) {
			return props.renderRightSide();
		}
	};

	const renderHeader = () => {
		if (props.renderHeader) {
			return (
				<div className="row no-gutters">
					<div className={'col-md-12' + ' ' + Styles.leftSideHeader}>
						<div className={Styles.modalHeader}>{props.renderHeader()}</div>
					</div>
				</div>
			);
		}
		return null;
	};

	return (
		<div className={'row' + ' ' + (props.cssClassName || '')}>
			<div className="col-md-12">
				{renderHeader()}
				<div className="row no-gutters">
					<div
						className={
							'col-md-' +
							(props.leftSideWidth ?? '6') +
							' ' +
							Styles.leftSide +
							(props.leftSideClassName ? ' ' + props.leftSideClassName : '')
						}
					>
						{renderLeftSide()}
					</div>
					<div
						className={
							'col-md-' +
							(props.rightSideWidth ?? '6') +
							' ' +
							Styles.rightSide +
							(props.rightSideClassName ? ' ' + props.rightSideClassName : '')
						}
					>
						{renderRightSide()}
					</div>
				</div>
			</div>
		</div>
	);
};
export default BCSplitModal;
